module.exports = __webpack_public_path__ + "static/media/partner-store-list-ic3.022e9ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/partner-store-list-ic3.png
// module id = 544
// module chunks = 0